module.exports = __webpack_public_path__ + "static/img/1.564c595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/1.jpg
// module id = PEkz
// module chunks = 0